/**
 * Lazy-loaders for Atlaskit icons referenced by Rovo Insights API icon keys.
 */
import type { ComponentType } from 'react';

import type { NewCoreIconProps } from '@atlaskit/icon/types';

/**
 * Lazy-loaded icon map — only the icon matching the API response is loaded,
 * avoiding eagerly importing all 33 icon modules upfront.
 */
export const LAZY_ICON_MAP: Record<
	string,
	() => Promise<{ default: ComponentType<NewCoreIconProps> }>
> = {
	alert: () => import('@atlaskit/icon/core/alert'),
	automation: () => import('@atlaskit/icon/core/automation'),
	'book-with-bookmark': () => import('@atlaskit/icon/core/book-with-bookmark'),
	briefcase: () => import('@atlaskit/icon/core/briefcase'),
	calendar: () => import('@atlaskit/icon/core/calendar'),
	'chart-bar': () => import('@atlaskit/icon/core/chart-bar'),
	'chart-trend-up': () => import('@atlaskit/icon/core/chart-trend-up'),
	'check-circle': () => import('@atlaskit/icon/core/check-circle'),
	clock: () => import('@atlaskit/icon/core/clock'),
	comment: () => import('@atlaskit/icon/core/comment'),
	compass: () => import('@atlaskit/icon/core/compass'),
	dashboard: () => import('@atlaskit/icon/core/dashboard'),
	department: () => import('@atlaskit/icon/core/department'),
	'eye-open': () => import('@atlaskit/icon/core/eye-open'),
	flag: () => import('@atlaskit/icon/core/flag'),
	globe: () => import('@atlaskit/icon/core/globe'),
	goal: () => import('@atlaskit/icon/core/goal'),
	lightbulb: () => import('@atlaskit/icon/core/lightbulb'),
	link: () => import('@atlaskit/icon/core/link'),
	megaphone: () => import('@atlaskit/icon/core/megaphone'),
	objective: () => import('@atlaskit/icon/core/objective'),
	'office-building': () => import('@atlaskit/icon/core/office-building'),
	'party-popper': () => import('@atlaskit/icon-lab/core/party-popper'),
	'people-group': () => import('@atlaskit/icon/core/people-group'),
	person: () => import('@atlaskit/icon/core/person'),
	'priority-high': () => import('@atlaskit/icon/core/priority-high'),
	'question-circle': () => import('@atlaskit/icon/core/question-circle'),
	sprint: () => import('@atlaskit/icon/core/sprint'),
	'star-starred': () => import('@atlaskit/icon/core/star-starred'),
	'status-warning': () => import('@atlaskit/icon/core/status-warning'),
	stopwatch: () => import('@atlaskit/icon/core/stopwatch'),
	target: () => import('@atlaskit/icon/core/target'),
	task: () => import('@atlaskit/icon/core/task'),
	teams: () => import('@atlaskit/icon/core/teams'),
	'thumbs-up': () => import('@atlaskit/icon/core/thumbs-up'),
	warning: () => import('@atlaskit/icon/core/status-warning'),
};
